export const podcastEmptyCatalog = {
	title: "No podcasts available yet",
	subtitle: "Podcasts are coming soon. Check back later for new episodes.",
} as const;

export const podcastEmptySaved = {
	title: "No saved podcasts",
	subtitle:
		"Save podcasts from the catalog to hear them offline and find them here.",
} as const;

export const podcastEmptySearchAll = {
	title: "No podcasts found",
	subtitle: "Try adjusting your search terms or browse all podcasts",
} as const;

export const podcastEmptySearchSaved = {
	title: "No saved podcasts found",
	subtitle: "Try adjusting your search or clear to see all saved podcasts",
} as const;
